module.exports = __webpack_public_path__ + "static/img/blogpost.92ccfffd.png";